export const getNodeId = (node) => node?.id;

export const getNodeRoleId = (node) => node?.role?.id;

export const getNodeShiftType = (node) => node?.shift_type;

export const getNodeShifts = (node) => node?.event_role_shifts_attributes ?? [];

export const getNodeTraining = (node) => node?.training_attributes;

export const getPersistedRoles = (attrs) => attrs?.event_roles ?? [];

export const getApplicantRoleId = (applicant) => applicant?.role?.id;

export const hasNestedError = (value) => {
  if (!value) return false;
  if (typeof value === "string") return true;
  if (Array.isArray(value)) return value.some(hasNestedError);
  if (typeof value === "object")
    return Object.values(value).some(hasNestedError);
  return false;
};

export const getRoleIndexFromPath = (path) => {
  const match = /^event_roles_attributes\.(\d+)/.exec(path);
  return match ? Number(match[1]) : null;
};

export const getShiftIndexFromPath = (path) => {
  const match =
    /^event_roles_attributes\.\d+\.event_role_shifts_attributes\.(\d+)/.exec(
      path
    );
  return match ? Number(match[1]) : null;
};

export const validationErrorToPath = (error) =>
  (Array.isArray(error?.inner) &&
    error.inner.find((item) => item?.path)?.path) ||
  error?.path ||
  "";

export const mergePersistedRoleIds = (roles, attrs) => {
  const persistedRoles = getPersistedRoles(attrs);
  if (!Array.isArray(persistedRoles) || !persistedRoles.length) return roles;

  const usedRoleIndexes = new Set();

  return roles.map((role) => {
    const persistedRoleIndex = persistedRoles.findIndex((candidate, index) => {
      if (usedRoleIndexes.has(index)) return false;
      return String(getNodeRoleId(candidate)) === String(role.role_id);
    });

    if (persistedRoleIndex === -1) return role;

    usedRoleIndexes.add(persistedRoleIndex);
    const persistedRole = persistedRoles[persistedRoleIndex];
    const persistedShifts = getNodeShifts(persistedRole);
    const usedShiftIndexes = new Set();

    return {
      ...role,
      id: role.id ?? getNodeId(persistedRole),
      event_role_shifts_attributes: role.event_role_shifts_attributes.map(
        (shift) => {
          const persistedShiftIndex = persistedShifts.findIndex(
            (candidate, index) => {
              if (usedShiftIndexes.has(index)) return false;
              return getNodeShiftType(candidate) === shift.shift_type;
            }
          );

          if (persistedShiftIndex === -1) return shift;

          usedShiftIndexes.add(persistedShiftIndex);
          const persistedShift = persistedShifts[persistedShiftIndex];
          const persistedTraining = getNodeTraining(persistedShift);
          const nextShift = {
            ...shift,
            id: shift.id ?? getNodeId(persistedShift),
          };

          if (shift.training_attributes && persistedTraining) {
            nextShift.training_attributes = {
              ...shift.training_attributes,
              id: shift.training_attributes.id ?? getNodeId(persistedTraining),
            };
          }

          return nextShift;
        }
      ),
    };
  });
};

/** Indexes of roles with errors, limited to roles that existed at the last continue attempt. */
export const getInvalidRoleIndexes = (roleErrors, validatedRoleCount) =>
  Array.isArray(roleErrors)
    ? roleErrors
        .map((roleError, index) =>
          roleError && index < validatedRoleCount ? index : null
        )
        .filter((index) => index !== null)
    : [];
